import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import ModalForms from '../Shared/Modals/index.js';
import CommonTable from '../Shared/Tables/TableV1.tsx';
import LongStringView from '../Shared/LongStringView/index.tsx';
import { dateFormate, generateFilterKey } from '../../utils/helper.jsx';
import { ConstantActions, LeadFormActions } from '../../Services/_actions';
import APIService from '../../Services/APIService.js';
import { useRecoilState, useRecoilValue } from 'recoil';
import { userInformationAtom } from '../../Services/_states/auth.js';
import SearchableDropdown from '../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
import { useSnackBar } from '../FlowBuilder/Common/SnackBar/index.tsx';
import LoadingButton from '../Shared/Loading/index.tsx';
import CommonBadges from '../Shared/Badges/index.jsx';
import { leadsTableStateAtom } from '../../Services/_states/index.js';

interface AssignLeadsModalProps {
  open: boolean;
  onClose: () => void;
  selectedLeads: any;
  campaignId: string;
  selectedRow?: any;
  handleRefresh?: (assignedUser: any) => void;
}

const AssignLeadsModal: React.FC<AssignLeadsModalProps> = ({
  open,
  onClose,
  selectedLeads = null,
  campaignId = '',
  selectedRow = null,
  handleRefresh = (assignedUser) => {
    console.log('handleRefresh not implemented');
  },
}) => {
  const actions = ConstantActions();
  const leadActions = LeadFormActions();
  const { showSnackBar } = useSnackBar();
  const loggedInUser = useRecoilValue(userInformationAtom);
  const organisationId = loggedInUser?.profile?.organisation?.organisation_id;
  const [userList, setUserList] = useState([]);
  const [isSaving, setIsaving] = useState(false);
  const [selectedUser, setSelectedUser] = useState<any[{ id: number | string }] | null>([]);
  // const [isUnAssigned, setIsUnAssigned] = useState(false);
  const [assignedUsers, setAssignedUsers] = useState<any[]>([]);
  const [unassignSelectedUser, setUnassignSelectedUser] = useState<any[]>([]);
  const tableState = useRecoilValue<any>(leadsTableStateAtom);
  const data_filters = tableState?.filters?.dynamicFilters || [];


  const getLeadIds = () => {
    // multiple
    if (selectedLeads && Object.keys(selectedLeads).length > 0) {
      return Object.keys(selectedLeads);
    }

    // single
    if (selectedRow?.lead_id) {
      return [selectedRow.lead_id];
    }

    return [];
  };


  const getUserMinimalList = async () => {
    try {
      if (organisationId && userList?.length <= 0 && campaignId) {
        const res: any = await actions.getUserMinimalList(organisationId, { campaign_id: campaignId ?? '' });
        setUserList(res ?? []);
      }
    } catch (err) {
      showSnackBar(err?.toString() ?? 'Server error. Please try again.', 'error');
    }
  };
  // useEffect(() => {
  //   getUserMinimalList();
  // }, [loggedInUser]);

  useEffect(() => {
    if (!open) return;
    if (!organisationId) return;
    if (!campaignId) return;
    if (userList.length > 0) return;

    getUserMinimalList();
  }, [open, organisationId, campaignId]);


  useEffect(() => {
    setSelectedUser([]);
    if (selectedRow && Object.keys(selectedRow).length > 0) {
      if (selectedRow?.lead_assignment?.length > 0) {
        const currentAssignedUsers = selectedRow?.lead_assignment?.map(item => ({
          ...item,
          id: Number(item?.lead_assigned_to)
        })) || [];
        setAssignedUsers(currentAssignedUsers);
      }
      // setIsUnAssigned(true);
    }
  }, [selectedRow]);

  // const LeadAssignment = async () => {
  //   try {
  //     setIsaving(true);
  //     const leadIds = Object.keys(selectedLeads) ?? [];

  //     const payload = {
  //       lead_ids: leadIds ?? [],
  //       assigned_to_user_ids: selectedUser.map((user: { id: number | string }) => user.id),
  //       campaign_id: campaignId,
  //     };
  //     const res: { status: number | null; data: any | null } =
  //       await leadActions.leadAssignment(payload);
  //     if (res?.status === 200) {
  //       const assignedUser = res?.data?.data?.assigned_users ?? [];
  //       showSnackBar('Leads Assigned successfully', 'success');
  //       onClose();
  //       handleRefresh(assignedUser);
  //     } else {
  //       showSnackBar(`Failed: ${res?.data?.system_error || 'Unknown error'}`, 'error');
  //     }
  //   } catch (err) {
  //     showSnackBar(err?.toString() ?? 'Server error. Please try again.', 'error');
  //   } finally {
  //     setIsaving(false);
  //   }
  // };

  // const LeadUnAssignment = async () => {
  //   try {
  //     const payload = {
  //       lead_ids: [selectedRow?.lead_id ?? ''],
  //       unassign_from_user_ids: selectedUser.map((user: { id: number | string }) => user.id),
  //       campaign_id: campaignId,
  //     };
  //     const res: { status: number | null; data: any | null } =
  //       await leadActions.leadUnAssignment(payload);
  //     if (res?.status === 200) {
  //       showSnackBar('Leads Unassigned successfully', 'success');
  //       onClose();
  //       handleRefresh(res?.data?.data?.unassigned_from_users ?? []);
  //     } else {
  //       showSnackBar(`Failed: ${res?.data?.system_error || 'Unknown error'}`, 'error');
  //     }
  //   } catch (err) {
  //     showSnackBar(err?.toString() ?? 'Server error. Please try again.', 'error');
  //   }
  // };
  const assignUsers = async () => {
    const leadIds = getLeadIds();

    if (leadIds.length === 0) {
      showSnackBar('Lead id not found', 'warning');
      return;
    }
    const payload = {
      lead_ids: leadIds,
      data_filters: data_filters,
      // lead_ids: leadIds ?? [],
      // lead_ids: [selectedRow?.lead_id ?? ''],
      assigned_to_user_ids: selectedUser.map((user: { id: number | string }) => user.id),
      campaign_id: campaignId,
    };
    const res: any = await leadActions.leadAssignment(payload);
    if (res?.status !== 200) {
      throw new Error(`Failed to assign users: ${res?.data?.data?.general_error?.message || 'Unknown error'}`);
    }
    return res;
  };

  const unassignUsers = async () => {
    const leadIds = getLeadIds();

    if (leadIds.length === 0) {
      showSnackBar('Lead id not found', 'warning');
      return;
    }
    try {
      const payload = {
        lead_ids: leadIds,
        data_filters: data_filters,
        // lead_ids: [selectedRow?.lead_id ?? ''],
        unassign_from_user_ids: unassignSelectedUser?.map((user: { id: number | string }) => user.id),
        campaign_id: campaignId,
      };
      const res: { status: number | null; data: any | null } =
        await leadActions.leadUnAssignment(payload);
      if (res?.status !== 200) {
        throw new Error(`Failed to unassign users: ${res?.data?.data?.general_error?.message || 'Unknown error'}`);
      } else {
        return res;
      }
    } catch (err) {
      showSnackBar(err?.toString() ?? 'Server error. Please try again.', 'error');
    }
  };
  const handleUnAssignedUser = (user) => {
    setUnassignSelectedUser([...unassignSelectedUser, user]);
    setAssignedUsers(assignedUsers?.filter(u => u.id !== user.id));
  }

  const getChanges = () => {
    const changes = {
      assignmentChanged: false,
      unassignmentChanged: false,
    };

    // Check assignment change
    if (selectedUser.length > 0) {
      changes.assignmentChanged = true;
    }

    // Check unassignment change
    if (unassignSelectedUser.length > 0) {
      changes.unassignmentChanged = true;
    }

    return changes;
  };

  const handleSubmit = async () => {
    setIsaving(true);

    try {
      const changes = getChanges();

      // Check if any changes were made
      if (!changes.assignmentChanged && !changes.unassignmentChanged) {
        showSnackBar('No changes detected', 'info');
        setIsaving(false);
        return;
      }
      // if (!selectedRow?.lead_id) {
      //   showSnackBar('Lead id not found', 'warning');
      //   setIsaving(false);
      //   return;
      // }

      const results: any = {};
      const operations: Promise<any>[] = [];
      const operationNames: string[] = [];

      if (changes?.assignmentChanged) {
        operations.push(assignUsers());
        operationNames.push('user assignment');
      }

      if (changes?.unassignmentChanged) {
        operations.push(unassignUsers());
        operationNames.push('user unassignment');
      }
      // Execute all operations
      const operationResults = await Promise.allSettled(operations);

      // Process results
      let successCount = 0;
      let errors: string[] = [];

      operationResults.forEach((result, index) => {
        if (result.status === 'fulfilled') {
          successCount++;
          if (operationNames[index] === 'user assignment') {
            results.assignmentResult = result.value;
          } else if (operationNames[index] === 'user unassignment') {
            results.unassignmentResult = result.value;
          }
        } else {
          errors.push(`${operationNames[index]}: ${result.reason.message}`);
        }
      });

      // Update table state for successful operations
      if (successCount > 0) {
        if (results?.assignmentResult || results?.unassignmentResult) {
          const unassignedUserIdsSet = new Set((results?.unassignmentResult?.data?.data?.unassigned_from_users ?? []).map(String));
          const assignedUsersData = results?.assignmentResult?.data?.data?.assigned_users ?? []
          const newUsers = assignedUsersData?.map((item) => ({ ...item, lead_assigned_to: String(item?.user_id ?? ""), id: String(item?.user_id ?? "") }));
          const result = newUsers?.filter(item => !unassignedUserIdsSet.has(item?.id));
          handleRefresh(result);
          setSelectedUser([]);
          setUnassignSelectedUser([]);
        }
      }

      // Show appropriate messages
      if (successCount === operations?.length) {
        showSnackBar(`All changes saved successfully!`, 'success');
        // Auto-close modal after successful submission
        setTimeout(() => {
          onClose();
        }, 1500);
      } else if (successCount > 0) {
        showSnackBar(`${successCount} out of ${operations?.length} operations completed successfully`, 'warning');
        if (errors.length > 0) {
          console.error('Partial failures:', errors);
        }
      } else {
        showSnackBar(`All operations failed: ${errors?.join(', ')}`, 'error');
      }

    } catch (error) {
      showSnackBar(error?.toString() || 'Unexpected error occurred', 'error');
    } finally {
      setIsaving(false);
    }
  };

  const hasChanges = () => {
    const changes = getChanges();
    return changes.assignmentChanged || changes.unassignmentChanged;
  };
  return (
    <ModalForms
      show={open}
      handleClose={onClose}
      modalHeader={'Assign & Unassign Lead'}
      size="sm"
      modalBody={
        <Box>
          {assignedUsers?.length > 0 && (
            <Box mb={2}>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Currently Assigned:
              </Typography>
              <Stack direction="row" spacing={1} flexWrap="wrap">
                {assignedUsers?.map((user, idx) => (
                  <Box key={idx}>
                    <CommonBadges
                      color="success"
                      value={user?.username || user?.name || 'Unknown User'}
                      variant="outlined"
                      onDelete={() => handleUnAssignedUser(user)}
                      showDelete={true}
                    />
                  </Box>

                ))}
              </Stack>
            </Box>
          )}
          <SearchableDropdown
            options={userList}
            value={selectedUser}
            labelKey="username"
            valueKey="id"
            onChange={(e) => {
              setSelectedUser(e);
            }}
            label={'Select User'}
            multiSelect={true}
            getOptionDisabled={(option) =>
              assignedUsers.some(u => u?.id === option?.id)
            }
          />
        </Box>
      }
      modalFooter={
        <Box display="flex" justifyContent={'flex-end'} gap={2}>
          <Button variant="outlined" size="small" onClick={onClose}>
            Cancel
          </Button>
          {/* <LoadingButton
            onClickButton={isUnAssigned ? LeadUnAssignment : LeadAssignment}
            isLoading={isSaving}
            buttonName={isUnAssigned ? 'Unassign Leads' : 'Assign Leads'}
          /> */}
          <LoadingButton
            buttonName="Save All Changes"
            onClickButton={handleSubmit}
            isLoading={isSaving}
            isDisabled={isSaving || !hasChanges()}
            size="medium"
            variant="contained"
          />

        </Box>
      }
    />
  );
};

export default AssignLeadsModal;
